import StnDetailContainer from '@components/containers/warehouseOps/stn/StnDetailContainer';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const StockTransferDetail: FC = () => (
    <AppLayout>
        <StnDetailContainer />
    </AppLayout>
);

export default StockTransferDetail;
